import { ROUTES } from '@dashboard/router/routeNames'

export default [
  {
    name: ROUTES.REVENUE,
    path: 'revenue',
    component: () => import('./pages/RevenueDashboard.vue'),
    meta: {
      title: 'Revenue'
    }
  }
]
